import { useAtomValue } from 'jotai';
import * as state from '@/components/Analysis/state';
import { PointOfInterestTemplateTypeEnum } from '@/__generated__/graphql';
import { convertTemplateNameToPoiType } from '@/utils';
import { useCallback } from 'react';
export const useIsPoiWorkScope = () => {
  const allPoiTemplates = useAtomValue(state.allPointOfInterestTemplates);
  const paintBlockPoiTemplates = allPoiTemplates.filter(
    (poi) => poi.type === PointOfInterestTemplateTypeEnum.PaintBlockVolumeOfInterest
  );

  const checkByType = useCallback(
    (poiType: string) => {
      const isWorkScope = paintBlockPoiTemplates.some(
        (poi) => convertTemplateNameToPoiType(poi.name) === poiType
      );
      return isWorkScope;
    },
    [paintBlockPoiTemplates]
  );

  return {
    checkByType,
  };
};
